import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function HeartFavoriteSecondaryButton({ isFavorite, onClick }: IFavoriteButtonProps) {
  const icon = isFavorite ? (
    <IconToggleHeartOn16 color="icon-negative-default" />
  ) : (
    <IconToggleHeartOff16 color="icon-negative-default" />
  );

  return <Button theme="fill_secondary" onClick={onClick} beforeIcon={icon} size="XS" />;
}
